export default {
    zh: {
        hello: '你好',
        home: '首页',
        nothing: '暂无更多内容',
    },
    ru: {
        hello: 'Здравствыйте',
        home: 'Главная',
        nothing: 'Ни о чем.',
    }
}